interface ErrorStatic {
  captureStackTrace(targetObject: object, constructorOpt?: unknown): void;
}

export interface DatadogErrorMessage {
  message: string;
  cause?: string;
  stack?: string;
}

/**
 * Extrai informações de erro e formata para estrutura DatadogErrorMessage
 * @param error - Erro desconhecido que pode ser Error, string, objeto ou outro tipo
 * @returns Objeto com message e opcionalmente cause, ou undefined se error for null/undefined
 */
export function extractError(error: unknown): DatadogErrorMessage | undefined {
  if (error === null || error === undefined) return undefined;
  if (error instanceof Error || isDatadogError(error))
    return {
      message: error.message,
      cause: stringfyCause(error.cause),
      stack: error.stack,
    };

  if (typeof error === 'string')
    return {
      message: error,
      stack: getCallStack(),
    };

  try {
    return {
      message: 'Ocorreu um erro',
      cause: JSON.stringify(error),
      stack: getCallStack(),
    };
  } catch (error: unknown) {
    const stack = error instanceof Error ? error.stack : undefined;

    return {
      message: 'Ocorreu um erro',
      cause: stringfyCause(error),
      stack: stack,
    };
  }
}

function getCallStack(): string | undefined {
  const stackObject: { stack?: string } = {};

  if ('captureStackTrace' in Error) {
    (Error as ErrorStatic).captureStackTrace(stackObject, extractError);
  }

  return stackObject.stack;
}

function stringfyCause(cause: unknown): string | undefined {
  if (cause === undefined) return undefined;
  if (cause === null) return 'null';
  if (['string', 'number', 'boolean'].includes(typeof cause))
    return String(cause);

  if (typeof cause === 'object' && Object.keys(cause).length === 0)
    return undefined;

  try {
    return JSON.stringify(cause);
  } catch {
    return String(cause);
  }
}

export function isDatadogError(error: unknown): error is DatadogErrorMessage {
  return (
    typeof error === 'object' &&
    error !== null &&
    'message' in error &&
    typeof (error as Record<string, unknown>)['message'] === 'string'
  );
}
